import React, { useState } from 'react';
import { connect } from 'react-redux';
import BtnGoogle from '../../../../../components/ButtonsRedesSign/BtnGoogle';
import BtnFB from '../../../../../components/ButtonsRedesSign/BtnFB';
import BtnEmail from '../../../../../components/ButtonsRedesSign/BtnEmail';
import { assertionStepClientSubmittedAction } from '../../../../../store/modules/assertionStepsClientSubmitted';
import BtnFace from '../../../../../components/ButtonsRedesSign/BtnFace';


const SignUpBtns = (props) => {
  const accountType = 'client';

  const handleSubmit = () => {
    const { submitStep, stepsClientSubmitted, history } = props;
    
    let steps = {
      ...stepsClientSubmitted,
      accountType
    };
    submitStep(steps).then(res => {
      history.push(`/usuario-registro/email-registro`);
    });
  };


  return (
    <>



      <BtnEmail click={handleSubmit} />
      <BtnFB />
      <BtnGoogle />



    </>

  );
}

const mapStateToProps = state => ({
  stepsClientSubmitted: state.stepsClientSubmitted
});

const mapDispatchToProps = dispatch => ({
  submitStep: steps => dispatch(assertionStepClientSubmittedAction(steps))
});

export default connect(mapStateToProps, mapDispatchToProps)(SignUpBtns);
